import 'angular';

import { ReportsLiteCtrl } from './reports';

angular.module('app-lite.reports', [])
  .controller('ReportsLiteCtrl', ReportsLiteCtrl);
